import { render, staticRenderFns } from "./directional_response.config.vue?vue&type=template&id=1ded0018"
import script from "./directional_response.config.vue?vue&type=script&lang=js"
export * from "./directional_response.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports